module.exports = __webpack_public_path__ + "img/Search_icon.a9cb853d.svg";